import { Draft, produce } from 'immer';
import { UserDraftsAction, UserDraftsActionTypes, UserDraftsState } from '@/redux/userDrafts/types';

const INITIAL_STATE: UserDraftsState = {
  drafts: [],
};

export const userDraftsReducer = produce(
  (draft: Draft<UserDraftsState>, action: UserDraftsAction) => {
    switch (action.type) {
      case UserDraftsActionTypes.SET_DRAFTS:
        draft.drafts = action.drafts;
        return draft;
      case UserDraftsActionTypes.SET_DRAFT:
        const index = draft.drafts.findIndex(
          (draft) => draft.userDraft.id === action.draft.userDraft.id
        );
        if (index === -1) {
          draft.drafts.push(action.draft);
        } else {
          draft.drafts[index] = action.draft;
        }
        return draft;
      case UserDraftsActionTypes.SET_ACTIVE_DRAFT:
        draft.activeDraft = { id: action.id, name: action.name };
        return draft;
      case UserDraftsActionTypes.DELETE_ACTIVE_DRAFT:
        draft.activeDraft = undefined;
        return draft;
      default:
        return draft;
    }
  },
  INITIAL_STATE
);
